import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@env';
import {Stripe, SetupIntentResult, PaymentMethodResult} from '@stripe/stripe-js';

@Injectable({
  providedIn: 'root'
})
export class BillingService {
  headers: HttpHeaders;
  apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.apiUrl;
  }

  getUrl(url): string {
    return `${this.apiUrl}/${url}`;
  }

  getPaymentMethods(data) {
    return this.http.post(this.getUrl('billing/get-payment-methods'), data)
      .toPromise();
  }

  getStripeBilling(data) {
    return this.http.post(this.getUrl('billing/get-stripe-billing'), data)
      .toPromise();
  }

  getPaymentIntent(data) {
    return this.http.post(this.getUrl('billing/get-payment-intent'), data)
      .toPromise();
  }

  getInvoices() {
    return this.http.post(this.getUrl('billing/get-invoices'), {})
      .toPromise();
  }

  payInvoice(data) {
    return this.http.post(this.getUrl('billing/pay-invoice'), data)
      .toPromise();
  }

  deleteInvoice(data) {
    return this.http.post(this.getUrl('billing/delete-invoice'), data)
      .toPromise();
  }

  deleteInvoiceItem(data) {
    return this.http.post(this.getUrl('billing/delete-invoice-item'), data)
      .toPromise();
  }

  setupIntent(data) {
    return this.http.post(this.getUrl('billing/setup-intent'), data)
      .toPromise();
  }

  paymentMethodSetupWithSecret(stripe: Stripe, secret, data): Promise<SetupIntentResult> {
    return stripe.confirmCardSetup(secret, {
      payment_method: data,
    });
  }

  paymentMethodSetupOneTime(stripe: Stripe, data): Promise<PaymentMethodResult> {
    return stripe.createPaymentMethod(data);
  }

  addPaymentMethod(data) {
    return this.http.post(this.getUrl('billing/add-payment-method'), data)
      .toPromise();
  }

  setDefaultPaymentMethod(data) {
    return this.http.post(this.getUrl('billing/set-payment-method'), data)
      .toPromise();
  }

  finalizePendingSetups(data) {
    return this.http.post(this.getUrl('billing/finalize-pending-setups'), data)
      .toPromise();
  }

  deletePaymentMethod(data) {
    return this.http.post(this.getUrl('billing/delete-payment-method'), data)
      .toPromise();
  }

  handleError(error: any) {
    if (!error.response || !error.response.data || !error.response.data) {
      throw {message: 'Unknown Error'};
    }
    throw error.response.data.error || error.response.data.message;
  }
}
